import { render } from "./searchVideos.vue?vue&type=template&id=0e81428a"
import script from "./searchVideos.vue?vue&type=script&lang=js"
export * from "./searchVideos.vue?vue&type=script&lang=js"

import exportComponent from "D:\\_laravelProjects\\2sport\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__